<div [class.p-4]="!dialogRef">

  <h4 mat-dialog-title>
    <span *ngIf="!altroSoggetto;else editHeader">
      Creazione nuovo altro soggetto
    </span>
    <ng-template #editHeader>
      Modifica altro soggetto {{altroSoggetto.humanIdentifier}}
    </ng-template>
  </h4>

  <form *ngIf="form;else loader" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">
    <mat-form-field>
      <mat-label>
        Tipo
      </mat-label>
      <tipo-altro-soggetto-picker formControlName="tipo"></tipo-altro-soggetto-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome" style="text-transform: uppercase;">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Cognome</mat-label>
      <input matInput formControlName="cognome" style="text-transform: uppercase;">
    </mat-form-field>

    <mat-form-field>

      <mat-label>
        Via / piazza
      </mat-label>
      <input matInput formControlName="via" style="text-transform: capitalize;">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        N. civico
      </mat-label>
      <input matInput formControlName="civico">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Comune
      </mat-label>
      <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        CAP
      </mat-label>
      <input matInput formControlName="cap"> 
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Partita IVA
      </mat-label>
      <input matInput formControlName="partita_iva">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Codice fiscale
      </mat-label>
      <input matInput formControlName="codice_fiscale">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        IBAN
      </mat-label>
      <input matInput formControlName="IBAN">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Note</mat-label>
      <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10"
        matInput formControlName="note"></textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Telefono
      </mat-label>
      <input matInput formControlName="tel">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Cellulare
      </mat-label>
      <input matInput formControlName="cell">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Fax
      </mat-label>
      <input matInput formControlName="fax">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Email
      </mat-label>
      <input matInput formControlName="email">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        SDI
      </mat-label>
      <input matInput formControlName="sdi">
    </mat-form-field>


  </form>
  <button mat-raised-button (click)="edit()" color="primary">Salva</button>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
